import { useGame } from "@/context/GameContext";
import { ITEM_ICON, itemName } from "@/lib/gameData";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

const SLOTS = 28;

export function InventoryGrid({ compact = false }) {
  const { snap, content, equip } = useGame();
  const inv = snap?.inventory || [];
  const cells = Array.from({ length: SLOTS }, (_, i) => inv[i] || null);

  async function tryEquip(slot) {
    if (!slot) return;
    const meta = content?.items?.[slot.item];
    if (meta?.cat !== "weapon") return;
    try { await equip(slot.item); toast.success(`Equipped ${meta.name}`); }
    catch (e) { toast.error(formatApiError(e)); }
  }

  return (
    <div
      className={`grid grid-cols-4 gap-1.5 ${compact ? "" : "max-w-xs"}`}
      data-testid="inventory-grid"
    >
      {cells.map((slot, i) => (
        <div
          key={i}
          className="inv-slot"
          onDoubleClick={() => tryEquip(slot)}
          title={slot ? `${itemName(slot.item, content?.items)} × ${slot.qty}\n(dbl-click to equip if weapon)` : "Empty"}
          data-testid={`inv-slot-${i}`}
        >
          {slot && (
            <>
              <span className="qty">{slot.qty > 1 ? slot.qty : ""}</span>
              <span className="text-2xl">{ITEM_ICON[slot.item] || "◇"}</span>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
